module.exports = __webpack_public_path__ + "static/media/ZHUHAI-1 02 (CAS 4B).46c3aec3.czml";